"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Styles = require("./search-field.styles");
class SearchField extends React.Component {
    constructor() {
        super(...arguments);
        this.ref = null;
        this.saveRef = (ref) => {
            this.ref = ref;
        };
    }
    componentDidMount() {
        if (this.props.autoFocus && this.ref) {
            const length = this.props.value.length;
            if (this.ref.tagName === 'INPUT') {
                const ref = this.ref;
                ref.focus();
                ref.setSelectionRange(length, length);
            }
        }
    }
    render() {
        const { props } = this;
        return (React.createElement(Styles.StyledSearchField, null,
            React.createElement(Styles.StyledIcon, { symbol: "search" }),
            React.createElement(Styles.StyledInputContainer, null,
                React.createElement(Styles.StyledInputSuggestion, { value: props.suggestion || "" }),
                React.createElement(Styles.StyledInput, { autoComplete: "off", autoFocus: props.autoFocus, name: props.name, onBlur: props.onBlur, onChange: props.onChange, onFocus: props.onFocus, onKeyDown: props.onKeyDown, placeholder: props.placeholder, title: props.title, type: "text", value: props.value, "data-search": props.mark, ref: this.saveRef })),
            props.children));
    }
}
exports.SearchField = SearchField;
//# sourceMappingURL=search-field.js.map